<div *ngIf="shouldRenderTabNavigation"
	class="nested-tab-navigation">
	<app-base-page-tab-menu
		[tabItems]="tabItems"
		[sectionItems]="sectionItems"
		[activeTabItem]="activeTabItem"
		[activeSectionItem]="activeSectionItem"
		[violatedTabKeys]="navigationViolationService.violatedNestedTabKeys"
		[violatedSectionKeys]="navigationViolationService.violatedSectionKeys"
		(tabSelectedEvent)="onTabSelectedEvent($event)">
	</app-base-page-tab-menu>
	<div class="multi-level-tab-shadow ui-g-12 no-padding"
		[ngClass]="{
			'anchors-menu-offset' : (activeSectionItem != null),
			'single-level-nav' : (tabItems.length <= 1 && sectionItems.length > 0)
		}">
	</div>
</div>

<div class="form-group custom-nested-tab-content ui-g-12"
	[attr.tab-key]="field.props.label"
	[ngClass]="{
		'visually-hidden': (field.props.visible === false)
	}"
	[style.border]="field.props.visible === false ? '0' : null"
	[style.clip]="field.props.visible === false ? 'rect(0 0 0 0)' : null"
	[style.height]="field.props.visible === false ? '1px' : null"
	[style.margin]="field.props.visible === false ? '-1px' : null"
	[style.overflow]="field.props.visible === false ? 'hidden' : null"
	[style.padding]="field.props.visible === false ? '0' : null"
	[style.position]="field.props.visible === false ? 'absolute' : null"
	[style.width]="field.props.visible === false ? '1px' : null">
	<ng-container #fieldComponent>
	</ng-container>
</div>